import { BusinessError, EntityKind, ErrorKind } from '../errors';
import { JustificationsStatuses } from '../types';
/**
 * Justifications service
 */
class JustificationsService {
    justificationsAdapter;
    constructor({ justificationsAdapter }) {
        this.justificationsAdapter = justificationsAdapter;
    }
    /**
     * Create justification through the adapter.
     */
    createJustification(justification) {
        const teleservice = justification.teleservice?.justification?.teleservices?.find(({ justificationType }) => justificationType === justification.kind);
        if (!teleservice) {
            throw new BusinessError(ErrorKind.NOT_FOUND, {
                entity: EntityKind.SOLLICITATIONS,
                href: justification.demande.href,
                message: `No teleservice for kind ${justification.kind}`,
            });
        }
        const date = new Date().toISOString();
        const justificationToCreate = {
            date,
            statut: JustificationsStatuses.REQUESTED,
            kind: justification.kind,
            // build teleservice with revision
            teleservice: {
                href: `${teleservice.href}?date=${date}`,
                title: teleservice.title,
            },
            demandeFinancement: {
                href: justification.demande.href,
                title: justification.demande.title,
                referenceAdministrative: justification.demande.referenceAdministrative,
            },
        };
        return this.justificationsAdapter.createJustification(justificationToCreate);
    }
}
export { JustificationsService };
//# sourceMappingURL=justifications-service.js.map